import { render, staticRenderFns } from "./_taskColor.vue?vue&type=template&id=2845ee5d"
import script from "./_taskColor.vue?vue&type=script&lang=js"
export * from "./_taskColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports